import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CallCenterRoutes: Routes = [
  {
    path: "call-center",
    loadComponent: () =>
      import("./call-center/call-center.component").then(
        (m) => m.CallCenterComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./call-center-list/call-center-list.component").then(
            (m) => m.CallCenterListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./ticket-details/ticket-details.component").then(
            (m) => m.TicketDetailsComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./ticket-details/ticket-details.component").then(
            (m) => m.TicketDetailsComponent,
          ),
      },
    ],
  },
];
